<template>
	<div class="main-bg">
		<remote-js src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></remote-js>
		<div class="main">
			<div class="content">
				<div class="left font-4">
					<p>一次偶然的机会，著名音乐家谷建芬与厦门大学这所百年老校结了缘。漫步在海风徐徐的校园，阅读着这所名校百年文化与芬芳，谷建芬被她特殊的气质和氛围所感动。在与师生的亲切交流与互动中，这位85岁高龄的老艺术家萌生了一个挥之不去的念头：这里不仅是一座学术的高地，更是艺术的殿堂，我要为她写一首歌……<br /><br /></p>
					<p>于是，一首青春洋溢的校园歌曲悄然构思，带着百年的眷念，带着对崭新未来的憧憬，舒展的音符和着春天的气息扑面而来……<br /><br /><p>
					<p>歌曲的创作过程中得到谷英、王持久、朱水涌、叶国平、张宏光、陈伟鸿等老师的大力支持，以及傅煜、周翔宇的友情付出。</p>
				</div>
				<div class="video">
					<div class="prism-player" id="J_prismPlayer"></div>
				</div>
				<div class="right">
					<img src="../img/ic34.png" />
					<div class="info font-4">
						<p v-html="'作&emsp;词：朱水涌'"></p>
						<p v-html="'作&emsp;曲：谷建芬'"></p>
						<p v-html="'配&emsp;器：张宏光'"></p>
					</div>
					<div class="an">
						<div v-html="'花&emsp;絮'"></div>
					</div>
					<div class="an" @click="about(5)">
						<div v-html="'音&emsp;乐'"></div>
					</div>
				</div>
			</div>
			<jm-nav></jm-nav>
		</div>
		<img src="../img/ic10.png" class="body-bg" />
	</div>
</template>
<script src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></script>
<script>
import jmNav from '../components/jm_nav.vue'
import remoteJs from '../components/remote_js.vue'
export default {
	data() {
		return {
		}
	},
	mounted() {
		this.checkPlay()
	},
	methods: {
		about(index){
			this.$router.push({ path:'/About/' + index + '.html'});
		},
		checkPlay(){
			if(window.Aliplayer !== undefined)
				new Aliplayer({ id: "J_prismPlayer", autoplay: true, width:"100%", height:"100%", source : "http://vod.xmupress.com/e337589afd424c538764bbbfbe7deb06/6a7278be9726420a80589a8d11577fe4.m3u8", cover:'', isLive: false,rePlay: false, playsinline: true,preload: true,controlBarVisibility: "hover", useH5Prism: true,format:'m3u8', }); 
			else
				setTimeout(this.checkPlay,20)
		}
	},
	components:{
		jmNav,
		remoteJs
	}
}
</script>
<style scoped>
@import "https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css";
.main{
	background: rgba(255,255,255,.3);
	width: 70rem;
	margin: 0 auto;
	border-radius: .5rem;
	padding-bottom: 2rem;
	z-index: 2;
	position: fixed;
	left: 50%;
	margin-left: -35rem;
	top: 50%;
	transform: translateY(-50%);
}
.main .content{
	padding-top: 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 31rem;
}
.main .right{
	margin-right: 4rem;
	align-items: center;
	display: flex;
	flex-direction: column;
}
.main .right img{
	display: flex;
	width: 6.5rem;
	position: relative;
	left: -.725rem;
}
.main .info{
	width: 6.5rem;
	margin: .75rem 0;
}
.main .info p{
	font-size: .9rem;
	color:#000;
	display: flex;
	height: 1.2rem;
	align-items: center;
	justify-content: center;
}
.body-bg{
	position: fixed;
	width: 100%;
	bottom: 0;
	left: 0;
}
.left{
	width: 20rem;
	margin-left: 2rem;
}
.left p{
	color:#92443c;
	font-size: 1rem;
	line-height: 1.6rem;
	text-indent: 2em;
}
.an{
	border-radius: .25rem;
	color: #cbb080;
	background-color: #d7412a;
	width: 5rem;
	height: 2rem;
	padding: .15rem;
	margin-bottom: .5rem;
	cursor: pointer;
}
.an div{
	border-radius: .25rem;
	border:1px solid #cbb080;
	height: 100%;
	display: flex;
	align-items: center;
	font-family: '宋体';
	justify-content: center;
	font-weight: bold;
	font-size: 1rem;
}
.video{
	width: 33.6rem;
	height: 22.1rem;
	background-color: #d7412a;
	border-radius: .15rem;
	padding: 1rem;
	display: flex;
	align-items: center;
}
</style>